import {Component, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Visibility} from '../../../models/prompt.model';
import {VisibilityComponent} from '../visibility/visibility.component';

@Component({
  selector: 'app-visibility-selector',
  imports: [
    VisibilityComponent
  ],
  templateUrl: './visibility-selector.component.html',
  host: {
    class: 'app-row-auto gapped tight'
  }
})
export class VisibilitySelectorComponent {
  readonly control = input.required<FormControl>()
  protected readonly visibilities: readonly Visibility[] = ['public', 'private']
}
